import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/ru';

moment.locale('ru');
Vue.use(require('vue-moment'), { moment });